export default "__VITE_PUBLIC_ASSET__e379422e__"